// Real content sourced from gpefrance.eu

export const contactInfo = {
  email: 'contact@gpefrance.eu',
  phone: '+33 4 42 07 22 62',
  address: "92 Bd de l’Europe ZA, 13127 Vitrolles",
  linkedin: 'https://www.linkedin.com/company/gpe-energies-services/',
  facebook: 'http://www.facebook.com/',
  instagram: 'http://www.instagram.com/',
};

export const navLinks = [
  { label: 'Accueil', href: '/' },
  { label: 'À propos de nous', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Références', href: '/references' },
  { label: 'International', href: '/international' },
  { label: 'Contact', href: '/contact' },
];

export const heroStats = [
  { value: '10+', label: "Des années d'expérience" },
  { value: '150+', label: 'Clients satisfaits' },
  { value: '8', label: "Domaines d'expertise" },
  { value: '100%', label: 'Satisfaction client' },
];

export const storyFeatures = [
  {
    title: 'Maîtrise électrique',
    desc: "Spécialistes de la gestion et de l’exploitation de réseaux d’infrastructures diverses, appréciés pour les professionnels et particuliers.",
  },
  {
    title: 'Solutions durables',
    desc: "Solutions d’avenir pour un approvisionnement énergétique durable, grâce aux énergies renouvelables et à l’efficacité énergétique.",
  },
  {
    title: 'Sur mesure',
    desc: "Solutions techniques et économiques adaptées aux secteurs tertiaire et industriel pour maximiser l’efficacité et réduire les coûts.",
  },
];

export const bottomStats = [
  { value: '150+', label: 'CLIENTS SATISFAITS' },
  { value: '10+', label: 'EMPLOYÉS' },
  { value: '10+', label: 'ANNÉES D’EXPÉRIENCE' },
];

export const services = [
  {
    slug: 'courants-forts',
    title: 'Courants forts',
    desc: "Distribution électrique, tableaux BT/HT, éclairage et équipements de puissance pour bâtiments tertiaires et industriels.",
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc4NDgxNjg0Mnww&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'courants-faibles',
    title: 'Courants faibles',
    desc: "Sûreté, contrôle d’accès, réseaux VDI, vidéosurveillance et systèmes de communication pour vos infrastructures.",
    image: 'https://images.unsplash.com/photo-1600132806370-bf17e65e942f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxlbmdpbmVlcmluZyUyMGJsdWVwcmludHxlbnwwfHx8fDE3ODQ4MTY4OTh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'energies-renouvelables',
    title: 'Énergies renouvelables',
    desc: "Solutions photovoltaïques et stockage batterie pour accélérer votre transition énergétique vers des sources durables.",
    image: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3ODQ4MTY4NDJ8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'mobilite-electrique',
    title: 'Mobilité électrique',
    desc: "Bornes de recharge pour véhicules électriques : de la wallbox résidentielle aux stations rapides en réseau (IRVE).",
    image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxFViUyMGNoYXJnaW5nfGVufDB8fHx8MTc4NDgxNjg0Mnww&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'renovation-energetique',
    title: 'Rénovation énergétique',
    desc: "Audit, conseil et travaux de rénovation pour réduire la consommation et valoriser durablement vos bâtiments.",
    image: 'https://images.unsplash.com/photo-1634586648651-f1fb9ec10d90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxidWlsZGluZyUyMHJlbm92YXRpb258ZW58MHx8fHwxNzg0ODE2ODk4fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'chauffage-climatisation',
    title: 'Chauffage et climatisation',
    desc: "Solutions CVC complètes : pompes à chaleur, climatisation et ventilation, de l’installation à la maintenance.",
    image: 'https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxodmFjJTIwc3lzdGVtfGVufDB8fHx8MTc4NDgxNjg5MXww&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'vrd',
    title: 'VRD (Voiries et Réseaux Divers)',
    desc: "Voiries, réseaux divers et aménagements extérieurs : terrassement, drainage et infrastructures de site.",
    image: 'https://images.unsplash.com/photo-1529792083865-d23889753466?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxyb2FkJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc4NDgxNjg5MXww&ixlib=rb-4.1.0&q=85',
  },
  {
    slug: 'bureau-etudes',
    title: "Bureau d'études",
    desc: "Ingénierie électrique, conception, dimensionnement et suivi de chantier au service de vos projets énergétiques.",
    image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3ODQ4MTY4NDJ8MA&ixlib=rb-4.1.0&q=85',
  },
];

export const partners = [
  { name: 'TotalEnergies', logo: '/images/clients/totalenergies.png' },
  { name: 'Circet France', logo: '/images/clients/csm_circet_france_f314466a96.png' },
  { name: 'EDF ENR', logo: '/images/clients/EDF_ENR_LOGO_RVB.webp' },
  { name: 'Métropole Aix Marseille Provence', logo: '/images/clients/1200px-Logo_M‚tropole_Aix_Marseille_Provence.svg.png' },
  { name: 'Enoé', logo: '/images/clients/logo_couleur_enoe_avec_baseline-8.png' },
  { name: 'Reference 222', logo: '/images/clients/222.png' },
  { name: 'Reference 222 alt', logo: '/images/clients/222 (1).png' },
  { name: 'Reference 333', logo: '/images/clients/333.png' },
  { name: 'Reference 333 alt', logo: '/images/clients/333 (1).png' },
  { name: 'Reference 444', logo: '/images/clients/444.png' },
  { name: 'Reference 555', logo: '/images/clients/555.png' },
  { name: 'Reference 666', logo: '/images/clients/666.png' },
  { name: 'Reference 3', logo: '/images/clients/REFERENCE3.png' },
  { name: 'Reference 4', logo: '/images/clients/REFERENCE4.png' },
  { name: 'Reference 7', logo: '/images/clients/REFERENCE7.png' },
  { name: 'Reference 8', logo: '/images/clients/REFERENCE8.png' },
  { name: 'Reference 9', logo: '/images/clients/REFERENCE9.png' },
  { name: 'Reference 11', logo: '/images/clients/REFERENCE11.png' },
  { name: 'Reference 12', logo: '/images/clients/REFERENCE12.png' },
  { name: 'Reference 13', logo: '/images/clients/REFERENCE13.png' },
  { name: 'Reference 14', logo: '/images/clients/REFERENCE14.png' },
  { name: 'Reference 16', logo: '/images/clients/REFERENCE16.png' },
  { name: 'Reference 18', logo: '/images/clients/REFERENCE18.png' },
  { name: 'Reference 20', logo: '/images/clients/REFERENCE20.png' },
  { name: 'Reference 21', logo: '/images/clients/REFERENCE21.png' },
  { name: 'Reference 22', logo: '/images/clients/REFERENCE22.png' },
  { name: 'Reference 23', logo: '/images/clients/REFERENCE23.png' },
  { name: 'Download 6', logo: '/images/clients/download-6.png' },
];

export const certifications = [
  { name: 'RGE QualiPV', desc: 'Solaire photovoltaïque', logo: '/images/certification/download-1.jpg' },
  { name: 'IRVE L500', desc: 'Recharge électrique', logo: '/images/certification/logo-IRVE-L500-1.jpg' },
  { name: 'OPQIBI', desc: "Ingénierie qualifiée", logo: '/images/certification/logo23.png' },
  { name: 'AFAQ ISO 9001', desc: 'Management de la qualité', logo: '/images/certification/logo25.png' },
];

export const logoUrl = 'https://customer-assets-4nw71qhi.emergentagent.net/job_gpe-preview/artifacts/e9obzzmb_NEW-WEBSITE-LOGO%20%281%29.png';

export const heroImage = 'https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3ODQ4MTY4NDJ8MA&ixlib=rb-4.1.0&q=85';

export const storyImage = 'https://images.pexels.com/photos/38171148/pexels-photo-38171148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
